import {fireChangeEvent} from "../../../default/global/js/utilities/fireEvent";
import {updateFilterViews} from "../custom/filter";

function showSortBySelect(sortBySelect) {
    if (sortBySelect) {
        if (window.outerWidth >= 768) {
            const dropdown = sortBySelect.querySelector(".sortBySelect__dropdown");
            if(dropdown) {
                dropdown.style.display = "block";
                setDropdownPosition(sortBySelect);
                dropdown.style.display = "";
            }
        }
        sortBySelect.classList.add("is-active");
    }
}

export function hideSortBySelect(sortBySelect) {
    if (sortBySelect) {
        resetDropdownPosition(sortBySelect);
        sortBySelect.classList.remove("is-active");
    }
}

export function hideAllSortBySelect() {
    for (let sortBySelect of document.querySelectorAll('.sortBySelect')) {
        hideSortBySelect(sortBySelect);
    }
}

function setActiveValueSortBySelect(input, selectedTrigger, dropdownItems, value = "") {
    input.value = value;
    let selectedText = "";
    let hasActive = false;
    for (let item of dropdownItems) {
        if (item.dataset.value === value) {
            item.classList.add("is-active");
            selectedText = item.querySelector('.sortBySelect__dropdownItemHeadline').innerHTML;
            hasActive = true;
        } else {
            item.classList.remove("is-active");
        }
    }
    if (hasActive) {
        selectedTrigger.innerHTML = selectedText;
    }
}

function setDropdownPosition(dropdownSelect) {

    if (window.innerWidth < 786) {
        return;
    }

    let dropdown = dropdownSelect.querySelector('.sortBySelect__dropdown');

    const dropdownBound = dropdown.getBoundingClientRect();
    const dropdownRight = dropdownBound.right;
    const dropdownBottom = dropdownBound.bottom;
    const dropdownHeight = dropdownBound.height;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const margin = 15;

    const stickyHeader = document.querySelector('.headerMain.sticky');
    let spaceOnTopAvailable;
    if ( stickyHeader ) {
        spaceOnTopAvailable = (dropdownBound.top - 50 - stickyHeader.getBoundingClientRect().height) > dropdownHeight;

    } else {
        spaceOnTopAvailable = (dropdownBound.top - 50) > dropdownHeight;
    }

    if ( (windowWidth - margin - dropdownRight) < 0 ) {
        dropdownSelect.classList.add('sortBySelect--openRight');
    }

    if ((windowHeight - margin - dropdownBottom) < 0 && spaceOnTopAvailable) {
        dropdownSelect.classList.add('sortBySelect--openTop');
    }

}

function resetDropdownPosition(dropdownSelect) {

    dropdownSelect.classList.remove('sortBySelect--openRight');
    dropdownSelect.classList.remove('sortBySelect--openTop');

}

export function initSortBySelects(wrapper = document) {
    for (let sortBySelect of wrapper.querySelectorAll(".js-sortBySelect")) {
        const input = sortBySelect.querySelector(".sortBySelect__hiddenFormField");
        const selectedTrigger = sortBySelect.querySelector('.sortBySelect__selected');
        const dropdown = sortBySelect.querySelector(".sortBySelect__dropdown");
        const dropdownItems = dropdown.querySelectorAll('.sortBySelect__dropdownItem:not(.disabled)');

        function resetSortBySelect(){
            input.value = 0;
            setActiveValueSortBySelect(input, selectedTrigger, dropdownItems, "");
            fireChangeEvent(input);
        }

        function sendSortByActionByAjax(){
            let itemListView = document.querySelector(".itemListView");
            if(itemListView){
                itemListView.classList.add("is-loading");
            }
            const formData = new FormData(sortBySelect);
            formData.append("isAjaxFilter",true);
            fetch('', {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Fehlerhafte Server-Antwort');
                    }
                    return response.text();
                })
                .then(data => {
                    const responseHtml = new DOMParser().parseFromString(data, 'text/html');
                    updateFilterViews(responseHtml, false, false, true);
                    const url = new URL(window.location.href);
                    url.searchParams.set(input.name, input.value);
                    window.history.pushState({}, '', url.toString());
                })
                .catch(error => {
                    console.error('Ajax-Fehler:', error);
                });
        }

        function updateSortBySelect(dropdownItem){
            let value = dropdownItem.dataset.value;
            if (value) {
                const sortBySelectActiveItems = sortBySelect.querySelectorAll(".sortBySelect__dropdownItem.is-active");
                if(sortBySelectActiveItems.length === 0){
                    resetSortBySelect();
                }else{
                    sendSortByActionByAjax();
                }
            }
        }

        if (input && selectedTrigger && dropdown) {
            if (dropdownItems) {
                setActiveValueSortBySelect(input, selectedTrigger, dropdownItems, input.value);
                for (let dropdownItem of dropdownItems) {
                    dropdownItem.addEventListener("click", function () {
                        setActiveValueSortBySelect(input, selectedTrigger, dropdownItems, dropdownItem.dataset.value);
                        updateSortBySelect(dropdownItem);
                    });
                }

            }
        }
        for(let close of sortBySelect.querySelectorAll(".sortBySelect__dropdownClose")){
            close.addEventListener("click",function (){
                hideSortBySelect(close);
            });
        }
        for(let trigger of sortBySelect.querySelectorAll(".sortBySelect__selected")){
            trigger.addEventListener("click",function (){
                if(sortBySelect.classList.contains('is-active')){
                    hideSortBySelect(sortBySelect);
                }else{
                    hideAllSortBySelect();
                    showSortBySelect(sortBySelect);
                }
            });
        }
    }
}